import { useEffect } from "react";
import { useLocation } from "@reach/router";
import { AnalyticsTracker, AdobeEvent } from "@world-vision/wv360-core-library";
import { ENV } from "gatsby-env-variables";

declare global {
  interface Window {
    _scrollTracker?: {
      callback: () => void;
      interval?: number;
      percent?: Record<number, boolean>;
    };
    adobeDataLayer?: AdobeEvent[];
  }
}

const usePageTracker = () => {
  const location = useLocation();
  console.log("PageTracker location", location);
  const { init, trackPage } = AnalyticsTracker();
  useEffect(() => {
    setTimeout(() => {
      console.log("PageTracker title and pathname", location.pathname, document.title);
      if (location.pathname !== "/") {
        console.log("PageTracker trackpage laoding", location);
        init();
        trackPage(ENV);
        console.log("PageTracker trackPage loaded", ENV);
      }
    }, 250);
  }, [location]);
  return null;
};

export default usePageTracker;
